import * as React from 'react'

function FacebookIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={5} height={10} {...props}>
      <path
        d="M4.736 5.46l.236-1.853H3.266V2.319a.64.64 0 01.629-.651h1.1V-.003H3.451a2.015 2.015 0 00-1.979 2.05v1.557H-.001v1.853h1.477v4.54h1.789v-4.54z"
        fill="#fff"
      />
    </svg>
  )
}

export default FacebookIcon
